import { render, staticRenderFns } from "./CheckoutsList.vue?vue&type=template&id=fd7dec90&"
import script from "./CheckoutsList.vue?vue&type=script&lang=js&"
export * from "./CheckoutsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports